import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  EyeIcon,
  EyeSlashIcon,
  UserIcon,
  EnvelopeIcon,
  LockClosedIcon,
} from "@heroicons/react/24/outline";

const InputField = ({
  type = "text",
  placeholder,
  name,
  value,
  onChange,
  icon
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const isPassword = type === "password";

  const getDefaultIcon = () => {
    switch (type) {
      case "text":
        return <UserIcon className="w-5 h-5 text-text-muted-light dark:text-text-muted-dark" />;
      case "email":
        return <EnvelopeIcon className="w-5 h-5 text-text-muted-light dark:text-text-muted-dark" />;
      case "password":
        return <LockClosedIcon className="w-5 h-5 text-text-muted-light dark:text-text-muted-dark" />;
      default:
        return null;
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;
    onChange && onChange(e);

    if (type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (val && !emailRegex.test(val)) {
        setError(t("validation.invalidEmail"));
      } else {
        setError("");
      }
    }
  };

  const IconComponent = icon;



  return (
    <div className="relative w-full">
      {/* Icon */}
      <div className="relative w-full">
        <span className="absolute -translate-y-1/2 start-3 top-1/2">
          {IconComponent ? (
            <IconComponent className="w-5 h-5 text-text-muted-light dark:text-text-muted-dark" />
          ) : (
            getDefaultIcon()
          )}
        </span>

        <input
          type={isPassword ? (showPassword ? "text" : "password") : type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          className={`w-full py-3 text-black border ps-10 rounded-xl dark:text-white bg-bg-light-primary dark:bg-bg-dark-primary border-border-light dark:border-border-dark focus:outline-none focus:ring focus:ring-primary-light dark:focus:ring-primary ${error ? "border-red-500" : ""
            }`}
        />
      </div>

      {/* Show / Hide password */}
      {isPassword && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute -translate-y-1/2 end-3 top-1/2 text-text-muted-light dark:text-text-muted-dark"
        >
          {showPassword ? <EyeIcon className="w-5 h-5" /> : <EyeSlashIcon className="w-5 h-5" />}
        </button>
      )}

      {/* Error message */}
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default InputField;
